import { api } from '@/lib/api';
import type { IApiResponse, ITeamCycleTimeResponse } from '@skystone/shared';

/** Cycle-time scatter scope: a single team, or a product pooled across its teams (PRODOPSAI-596). */
interface TeamCycleTimeParams {
  teamId?: string;
  productId?: string;
  from: string;
  to: string;
  /** PRODOPSAI-621: include archived teams in pooled scopes. Default false. */
  includeArchived?: boolean;
}

function buildCycleTimeSearch(params: TeamCycleTimeParams): string {
  const search = new URLSearchParams();
  if (params.teamId) search.set('teamId', params.teamId);
  if (params.productId) search.set('productId', params.productId);
  search.set('from', params.from);
  search.set('to', params.to);
  // PRODOPSAI-621: omitted entirely when not opted in.
  if (params.includeArchived === true) search.set('includeArchived', 'true');
  return search.toString();
}

export const teamMetricsApi = {
  getCycleTime: async (params: TeamCycleTimeParams): Promise<ITeamCycleTimeResponse> => {
    const res = await api.get<IApiResponse<ITeamCycleTimeResponse>>(
      `/team-metrics/cycle-time?${buildCycleTimeSearch(params)}`,
    );
    return res.data;
  },
};
